import React from 'react';
import { useTranslation } from 'react-i18next';
import type { EvaluationStatistics } from '@/types/overview';
import { toPercentage } from '@/utils/text';

interface Props {
  statistics: EvaluationStatistics;
  studentPlace: number;
}

export const EvaluationChart: React.FC<Props> = ({
  statistics,
  studentPlace,
}) => {
  const { t } = useTranslation();

  const {
    chartItems,
    indexOfStudentEvaluation,
    averageClassEvaluation: average,
  } = statistics;
  const maxValue = Math.max(...chartItems);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex h-[148px] items-end gap-2">
        {chartItems.map((value, index) => (
          <span
            key={index}
            className={`flex-1 rounded ${index === indexOfStudentEvaluation ? 'bg-accent' : 'bg-on-primary-surface'}`}
            style={{ height: toPercentage((value / maxValue) * 100) }}
          />
        ))}
      </div>

      <div className="text-body-14 flex items-center justify-between gap-3 text-subtle-foreground">
        {!!average && <span>{t('diary.evaluation.average', { average })}</span>}
        <span className="ml-auto">
          {t('diary.evaluation.place', {
            place: studentPlace,
            total: chartItems.length,
          })}
        </span>
      </div>
    </div>
  );
};
